









































import { Vue, Component, PropSync, Watch } from 'vue-property-decorator'
import axios, { AxiosResponse } from 'axios'

interface DiscordWidgetResponse {
  id: string
  name: string
  // eslint-disable-next-line camelcase
  instant_invite: string
  channels: string[]
  members: string[]
  // eslint-disable-next-line camelcase
  presence_count: number
}

@Component
export default class HelpDialog extends Vue {
  @PropSync('visible', { type: Boolean })
  isVisible!: boolean

  discordInvite: string = ''

  @Watch('isVisible')
  async onVisibilityChanged(visible: boolean) {
    if (!visible) return
    await this.fetchDiscordInvites()
  }

  async fetchDiscordInvites() {
    try {
      const response = (await axios.get(
        'https://discordapp.com/api/guilds/743065796347166781/widget.json'
      )) as AxiosResponse<DiscordWidgetResponse>
      if (response) {
        let inviteCode = response.data.instant_invite.replace(
          'https://discordapp.com/invite/',
          ''
        )
        this.discordInvite = `https://vsarena.gg/discord/?invite=${inviteCode}`
      }
    } catch (err) {
      console.error(err)
    }
  }
}
